import React, { useState } from "react";
import { GLMappingEntity } from "../../domain/entities/GLMappingEntity";
import { useGlParentAccountTree } from "../hooks/useGlParentAccountTree";
import { useGlParentGroupTree } from "../../../features/gls/presentation/hooks/useGlParentGroupTree";
import { getStoredAccountingBackend } from "../../../config/accounting";
import { GlTreePickerShell } from "./GlTreePickerShell";

export interface GlParentAccountDropdownProps {
  accountType: string;
  selectedAccountId?: string;
  selectedAccountName?: string;
  excludeAccountId?: string;
  onSelect: (account: GLMappingEntity) => void;
  disabled?: boolean;
  className?: string;
  dropdownClassName?: string;
  placeholder?: string;
}

export function GlParentAccountDropdown({
  accountType,
  selectedAccountId,
  selectedAccountName,
  excludeAccountId,
  onSelect,
  disabled = false,
  className = "",
  dropdownClassName = "",
  placeholder = "Select parent account",
}: GlParentAccountDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isTally = getStoredAccountingBackend() === "tally";
  const accountTypeReady = accountType.trim() !== "";
  const treeEnabled = isOpen && !disabled && accountTypeReady;

  const zohoTreeState = useGlParentAccountTree({
    accountType,
    selectedAccountId,
    excludeAccountId,
    enabled: treeEnabled && !isTally,
  });

  const tallyTreeState = useGlParentGroupTree({
    accountType,
    selectedAccountId,
    enabled: treeEnabled && isTally,
  });

  const treeState = isTally ? tallyTreeState : zohoTreeState;

  return (
    <GlTreePickerShell
      treeState={treeState}
      selectedAccountId={selectedAccountId}
      selectedAccountName={selectedAccountName}
      onSelect={onSelect}
      disabled={disabled || !accountTypeReady}
      className={className}
      dropdownClassName={dropdownClassName}
      placeholder={placeholder}
      searchPlaceholder={
        isTally ? "Search parent groups…" : "Search parent accounts…"
      }
      selectionMode="any"
      singleAccountType={accountType}
      autoExpandSingleGroup
      onOpenChange={setIsOpen}
    />
  );
}

export default GlParentAccountDropdown;
